import React, { Component } from "react";
import { Switch, Route, Link } from "react-router-dom";

export default function PApsPaymentMethods () {

    return (
      <div className="payment-systems-container">
<div className="payment-systems-container__filter-view">
<div className="xsui-select">
<div className="xsui-dropdown">
<div style={{display: 'block'}}>
<div style={{position: 'relative', width: '100%', display: 'block'}}>
<button name="payments-methods-filter-categories" value="All categories" placeholder="All categories" className="xsui-input xsui-input--size-sm xsui-input--appearance-primary xsui-input--offset-right xsui-input--read-only" type="button" data-id="payments-methods-filter-categories" data-value="All categories">All categories</button>
<div className="xsui-input__icon">
<i className="xsui-icon xsui-icon-dropdown-select" style={{fontSize: 24, color: 'inherit'}} />
</div>
</div>
<div />
</div>
<div />
</div>
</div>
<div className="xsui-select">
<div className="xsui-dropdown">
<div style={{display: 'block'}}>
<div style={{position: 'relative', width: '100%', display: 'block'}}>
<button name="payments-methods-filter-currencies" value="All currencies" placeholder="All currencies" className="xsui-input xsui-input--size-sm xsui-input--appearance-primary xsui-input--offset-right xsui-input--read-only" type="button" data-id="payments-methods-filter-currencies" data-value="All currencies">All currencies</button>
<div className="xsui-input__icon">
<i className="xsui-icon xsui-icon-dropdown-select" style={{fontSize: 24, color: 'inherit'}} />
</div>
</div>
<div />
</div>
<div />
</div>
</div>
<div className="xsui-select">
<div className="xsui-dropdown">
<div style={{display: 'block'}}>
<div style={{position: 'relative', width: '100%', display: 'block'}}>
<button name="payments-methods-filter-regions" value="All regions" placeholder="All regions" className="xsui-input xsui-input--size-sm xsui-input--appearance-primary xsui-input--offset-right xsui-input--read-only" type="button" data-id="payments-methods-filter-regions" data-value="All regions">All regions</button>
<div className="xsui-input__icon">
<i className="xsui-icon xsui-icon-dropdown-select" style={{fontSize: 24, color: 'inherit'}} />
</div>
</div>
<div />
</div>
<div />
</div>
</div>
<div className="xsui-select">
<div className="xsui-dropdown">
<div style={{display: 'block'}}>
<div style={{position: 'relative', width: '100%', display: 'block'}}>
<button name="payments-methods-filter-countries" value="All countries" placeholder="All countries" className="xsui-input xsui-input--size-sm xsui-input--appearance-primary xsui-input--offset-right xsui-input--read-only" type="button" data-id="payments-methods-filter-countries" data-value="All countries">All countries</button>
<div className="xsui-input__icon">
<i className="xsui-icon xsui-icon-dropdown-select" style={{fontSize: 24, color: 'inherit'}} />
</div>
</div>
<div />
</div>
<div />
</div>
</div>
<div style={{display: 'block'}}>
<div style={{position: 'relative', width: '100%', display: 'block'}}>
<input name="payments-methods-filter-name" placeholder="Search for..." className="xsui-input xsui-input--size-sm xsui-input--appearance-primary xsui-input--offset-left" type="text" data-id="payments-methods-filter-name" data-value defaultValue />
<div className="xsui-input__icon">
<i className="xsui-icon xsui-icon-search" style={{fontSize: 24, color: 'inherit'}} />
</div>
</div>
<div />
</div>
</div>
<div className="payment-systems-container__header2">
<div>
<span>287 payment methods found</span>
</div>
<div className="payment-systems-container__download-xls">
<img className="payment-systems-container__xls-icon" src="//cdn.xsolla.net/publisher-v4/download.168a0c.svg" />
<div className="payment-systems-container__xls-button-text">Download XLS</div>
</div>
</div>
<div className="ui-table">
<div className="ui-table__head">
<div className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>Payment method</div>
<div className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>Categories</div>
<div className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>Fee</div>
<div className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>Conditions</div>
<div className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>Regions</div>
<div className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>Countries</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>Status</div>
</div>
<div className="ui-table__body">
<div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[0]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/2632.1555588542.png")'}} />
<div>
<div className="payment-col__name">24AllTime</div>
<div className="payment-col__id">ID 2632</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Cash Payments</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">4.8 % </span>
<br />
<div className="payment-systems-container__currencies">RUB</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">CIS</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Russia</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[1]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/2546.1447070574.png")'}} />
<div>
<div className="payment-col__name">4B Card </div>
<div className="payment-col__id">ID 2546</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Credit/Debit Cards</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">3.99 % + $0.22</span>
<br />
<div className="payment-systems-container__currencies">EUR, USD</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Western Europe</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Spain</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[2]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/1776.1542698832.png")'}} />
<div>
<div className="payment-col__name">7Eleven</div>
<div className="payment-col__id">ID 1776</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Cash Payments</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">15 % </span>
<br />
<div className="payment-systems-container__currencies">USD, PHP</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Southeast Asia, North America</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Philippines, USA</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[3]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/1514.1447067456.png")'}} />
<div>
<div className="payment-col__name">ABN AMRO</div>
<div className="payment-col__id">ID 1514</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Bank Transfer</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">0 % + €0.70</span>
<br />
<div className="payment-systems-container__currencies">EUR</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Western Europe</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Netherlands</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[4]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/1877.1447068770.png")'}} />
<div>
<div className="payment-col__name">ACB</div>
<div className="payment-col__id">ID 1877</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Bank Transfer</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">5.5 % </span>
<br />
<div className="payment-systems-container__currencies">VND</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Southeast Asia</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Vietnam</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[5]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/2932.1555589322.png")'}} />
<div>
<div className="payment-col__name">ACE Cash Express</div>
<div className="payment-col__id">ID 2932</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Cash Payments</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">3 % </span>
<br />
<div className="payment-systems-container__currencies">USD</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">North America</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">USA</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[6]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/3228.1555590801.png")'}} />
<div>
<div className="payment-col__name">activ.kz</div>
<div className="payment-col__id">ID 3228</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Mobile Payments</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">8 % </span>
<br />
<div className="payment-systems-container__currencies">KZT</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">CIS</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Kazakhstan</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[7]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/1879.1447068773.png")'}} />
<div>
<div className="payment-col__name">Agribank</div>
<div className="payment-col__id">ID 1879</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Bank Transfer</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">5.5 % </span>
<br />
<div className="payment-systems-container__currencies">VND</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Southeast Asia</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Vietnam</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[8]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/1891.1532666945.png")'}} />
<div>
<div className="payment-col__name">AirBank</div>
<div className="payment-col__id">ID 1891</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Bank Transfer</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">0.99 % </span>
<br />
<div className="payment-systems-container__currencies">CZK</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">Payment Amount &lt; 200.6 CZK</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Eastern Europe</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Czech Republic</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[9]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/3197.1555590567.png")'}} />
<div>
<div className="payment-col__name">Akbank</div>
<div className="payment-col__id">ID 3197</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Bank Transfer</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">1 % </span>
<br />
<div className="payment-systems-container__currencies">TRY</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Eastern Europe</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Turkey</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[10]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/3244.1557904458.png")'}} />
<div>
<div className="payment-col__name">Aktia</div>
<div className="payment-col__id">ID 3244</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Bank Transfer</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">0 % + €0.75</span>
<br />
<div className="payment-systems-container__currencies">EUR</div>
</div>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">0 % + €15.00</span>
<br />
<div className="payment-systems-container__currencies">EUR</div>
</div>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">1.5 % </span>
<br />
<div className="payment-systems-container__currencies">EUR</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
<div className="payment-systems-container__cc-col">—</div>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Western Europe</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Finland</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[11]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/309.1521725031.png")'}} />
<div>
<div className="payment-col__name">Alfa Click</div>
<div className="payment-col__id">ID 309</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Bank Transfer</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">4 % </span>
<br />
<div className="payment-systems-container__currencies">RUB</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">CIS</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Russia</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[12]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/3404.1542371462.png")'}} />
<div>
<div className="payment-col__name">Alfa Express</div>
<div className="payment-col__id">ID 3404</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Cash Payments</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">0 % + IDR&nbsp;5,000.00</span>
<br />
<div className="payment-systems-container__currencies">IDR</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Southeast Asia</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Indonesia</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[13]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/3325.1513599121.png")'}} />
<div>
<div className="payment-col__name">Alfamart</div>
<div className="payment-col__id">ID 3325</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Cash Payments</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">0 % + IDR&nbsp;5,000.00</span>
<br />
<div className="payment-systems-container__currencies">IDR</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Southeast Asia</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Indonesia</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[14]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/3405.1555591357.png")'}} />
<div>
<div className="payment-col__name">Alfamidi</div>
<div className="payment-col__id">ID 3405</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Cash Payments</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">0 % + IDR&nbsp;5,000.00</span>
<br />
<div className="payment-systems-container__currencies">IDR</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Southeast Asia</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Indonesia</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[15]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/3175.1532669069.png")'}} />
<div>
<div className="payment-col__name">
  <a title="apple" link="apple"/>
  Apple Pay</div>
<div className="payment-col__id">ID 3175</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>E-payment Options</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">2.9 % + $0.30</span>
<br />
<div className="payment-systems-container__currencies">USD</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Asia-Pacific, North America, Western Europe, Southeast Asia</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip cell-tooltip--with-hover">
<div className="cell-tooltip__view">Australia, Canada, Switzerland, China, France, United Kingdom, Singapore, USA</div>
<div className="cell-tooltip__hover">
<div>Australia</div>
<div>Canada</div>
<div>China</div>
<div>France</div>
<div>Singapore</div>
<div>Switzerland</div>
<div>USA</div>
<div>United Kingdom</div>
</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[16]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/1515.1447067459.png")'}} />
<div>
<div className="payment-col__name">ASN Bank</div>
<div className="payment-col__id">ID 1515</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Bank Transfer</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">0 % + €0.70</span>
<br />
<div className="payment-systems-container__currencies">EUR</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Western Europe</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Netherlands</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[17]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/3324.1555591030.png")'}} />
<div>
<div className="payment-col__name">ATM/Bank Transfer</div>
<div className="payment-col__id">ID 3324</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Cash Payments, Bank Transfer</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">0 % + IDR&nbsp;5,000.00</span>
<br />
<div className="payment-systems-container__currencies">IDR</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Southeast Asia</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Indonesia</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[18]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/3334.1555591074.png")'}} />
<div>
<div className="payment-col__name">Baloto</div>
<div className="payment-col__id">ID 3334</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Cash Payments</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">4 % + $0.20</span>
<br />
<div className="payment-systems-container__currencies">COP</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Latin America</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Colombia</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[19]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '20%'}}>
<div className="payment-col">
<div className="payment-col__img" style={{backgroundImage: 'url("//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/2133.1532667773.png")'}} />
<div>
<div className="payment-col__name">Banco de Chile</div>
<div className="payment-col__id">ID 2133</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<span className>Bank Transfer</span>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">
<span className="payment-systems-container__perc-value">4 % + CLP&nbsp;150</span>
<br />
<div className="payment-systems-container__currencies">CLP</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div className>
<div className="payment-systems-container__cc-col">—</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Latin America</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '14%'}}>
<div style={{position: 'relative'}}>
<div className="cell-tooltip">
<div className="cell-tooltip__view">Chile</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '10%'}}>
<div className="xsui-switch-container">
<div className="xsui-switch xsui-switch--align-right">
<label data-id="toggle-pay-system-status" data-value="true">
<input name="toggle-pay-system-status" className type="checkbox" defaultValue="true" defaultChecked />
<div className="xsui-switch__status">
<div className="xsui-switch__status__off">Off</div>
<div className="xsui-switch__status__on">On</div>
</div>
</label>
<div className="xsui-switch__description xsui-switch__description--align-right" />
</div>
</div>
</div>
</div>
</div>
</div>
</div>
<div className="payment-systems-container__more">
<button className="xsui-button xsui-button--appearance-primary xsui-button--size-sm" type="button">
<div className="xsui-button__wrapper">
<div className="xsui-button__content">Show more</div>
</div>
</button>
</div>
</div>

    );

}
